class Ajaxinate {
  constructor() {
    this.container = document.querySelector('[data-ajaxinate-container]');
    this.loadMoreBtn = document.querySelector('[data-ajaxinate-load-more]');
    this.loading = false;
    this.deferredProducts = [];

    if (!this.container || !this.loadMoreBtn) return;
    if (this.loadMoreBtn.dataset.ajaxinateBound === 'true') return;

    this.loadMoreBtn.dataset.ajaxinateBound = 'true';

    this.loadMoreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.loadMore();
    });
  }

  async loadMore() {
    if (this.loading) return;
    this.loading = true;

    const url = this.loadMoreBtn.getAttribute('href');
    if (!url) {
      this.loading = false;
      return;
    }

    this.loadMoreBtn.classList.add('loading');

    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newPagination = html.querySelector('[data-ajaxinate-load-more]');

      let newProducts = [];
      if(html.querySelectorAll( '[data-ajaxinate-container] .grid__item').length > 0) {
        newProducts = html.querySelectorAll( '[data-ajaxinate-container] .grid__item');
      } else {
        newProducts = html.querySelectorAll( '[data-ajaxinate-container] .blog-articles__article');
      }

      let productsToAppend = Array.from(newProducts).filter((item) => !item.classList.contains('collection-promo-banner'));
      const loadMoreBatchSize = parseInt(this.container.dataset.loadMoreBatchSize || '0', 10);

      if (loadMoreBatchSize > 0) {
        productsToAppend = this.deferredProducts.concat(productsToAppend);

        if (newPagination && productsToAppend.length > loadMoreBatchSize) {
          this.deferredProducts = productsToAppend.slice(loadMoreBatchSize);
          productsToAppend = productsToAppend.slice(0, loadMoreBatchSize);
        } else {
          this.deferredProducts = [];
        }
      }

      productsToAppend.forEach((item) => {
        this.container.appendChild(item);
      });

      if (newPagination) {
        this.loadMoreBtn.setAttribute(
          'href',
          newPagination.getAttribute('href')
        );
      } else {
        if (this.deferredProducts.length) {
          this.deferredProducts.forEach((item) => {
            this.container.appendChild(item);
          });
          this.deferredProducts = [];
        }
        this.loadMoreBtn.remove();
      }
    } catch (error) {
      console.error('Ajaxinate error:', error);
    } finally {
      this.loadMoreBtn.classList.remove('loading');
      this.loading = false;
      const sliders = document.querySelectorAll(".product-card-swiper:not([data-slider-init])");
      sliders.forEach(function (slider) {
        slider.setAttribute('data-slider-init', 'true');
        
        const productId = slider.getAttribute("data-product-id");
        const wrapper = slider.querySelector('.swiper-wrapper');
        const slides = slider.querySelectorAll('.swiper-slide');
        const cardWrapper = slider.closest(".card-wrapper");
        
        if (!wrapper || slides.length < 2 || !cardWrapper) return;
        
        const prevBtn = cardWrapper.querySelector(`#product-card-prev${productId}`);
        const nextBtn = cardWrapper.querySelector(`#product-card-next${productId}`);
        
        if (!prevBtn || !nextBtn) return;
        
        let currentIndex = 0;
        const totalSlides = slides.length;
        
        // Set up CSS for vanilla slider
        wrapper.style.display = 'flex';
        wrapper.style.transition = 'transform 0.3s ease';
        
        slides.forEach(function(slide) {
          slide.style.flexShrink = '0';
          slide.style.width = '100%';
        });
        
        function goToSlide(index) {
          if (index >= totalSlides) index = 0;
          if (index < 0) index = totalSlides - 1;
          currentIndex = index;
          wrapper.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
        }
        
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          goToSlide(currentIndex + 1);
        });
        
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          goToSlide(currentIndex - 1);
        });
      });
    }
  }
}

function initializeAjaxinate() {
  return new Ajaxinate();
}

window.initializeAjaxinate = initializeAjaxinate;

document.addEventListener('DOMContentLoaded', () => {
  initializeAjaxinate();
});
 